module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main payment"
  }, [_c('div', {
    staticClass: "part1"
  }, [_c('div', [_c('div', {
    staticClass: "payment-title"
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title1')) + "：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('prices-payment-title1')
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "payment-option"
  }, [_c('div', {
    staticClass: "payment-title"
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title3')) + "：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('prices-payment-title4')
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "total-price"
  }, [_c('span', {
    staticClass: "payment-title"
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title5')) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "payment-title price"
  }, [_vm._v(_vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "payment-title"
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title6')) + "：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "PayPal"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("PayPal")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pay"
    },
    on: {
      "click": _vm.orderConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title8')))])]), _vm._v(" "), _c('div', {
    staticClass: "part2"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('prices-payment-title9')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "agreement"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/permission/#/agreement"
    }
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title10')))])]), _vm._v(" "), _c('div', {
    staticClass: "policy"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/permission/#/privacypolicy"
    }
  }, [_vm._v(_vm._s(_vm.$t('prices-payment-title11')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1f95a5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/Payment.vue
// module id = 306
// module chunks = 1